<template>
    <div>
        <div class="bgfff" v-if="aqglworks.length > 0">
            <div class='container-types clearfix'>
                <h3 class='types-title'><span
                        class="tit-icon icon-shizhan-l tit-icon-l"></span><em>危</em>／<em><em>险</em>／<em><em>化</em>／<em><em>学</em>／<em><em>品</em>／<em><em>安</em>／<em>全</em>／<em>管</em>／<em>理</em>／<em>人</em>／<em>员</em><span
                        class="tit-icon icon-shizhan-r tit-icon-r"></span>
                </h3>
                <div class='clearfix types-content'>
                    <div v-for="item in aqglworks"
                         class='index-card-container course-card-container container showstyee'>
                        <a class='course-card'
                           @click="goclass(item._id)">
                            <!--<div class="course-stat new">-->
                            <!--NEW-->
                            <!--</div>-->
                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span><em> {{item.gzcxjg | format}} </em>
                                    </div>
                                    <div class='course-card-price'><span>复审/换证</span><em> {{item.gzfsjg | format}}</em>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg000" v-if="tzzyworks.length > 0">
            <div class='container-types clearfix'>
                <h3 class='types-title'><span
                        class="tit-icon icon-new-l tit-icon-l"></span><em>特</em>／<em>种</em>／<em>作</em>／<em>业</em>／<em>人</em>／<em>员</em><span
                        class="tit-icon icon-new-r tit-icon-r"></span>
                </h3>
                <div class='clearfix types-content'>
                    <div v-for="item in tzzyworks"
                         class='index-card-container course-card-container container showstyee'>
                        <a class='course-card'
                           @click="goclass(item._id)">
                            <!--<div class="course-stat new">-->
                            <!--NEW-->
                            <!--</div>-->
                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span> ￥{{item.gzcxjg}}.00</div>
                                    <div class='course-card-price'><span>复审/换证</span>￥{{item.gzfsjg}}.00</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bgfff" v-if="tzsbworks.length > 0">
            <div class='container-types clearfix'>
                <h3 class='types-title'><span
                        class="tit-icon icon-job-l tit-icon-l"></span><em>特</em>／<em>种</em>／<em>设</em>／<em>备</em>／<em>作</em>／<em>业</em>／<em>人</em>／<em>员</em><span
                        class="tit-icon icon-job-r tit-icon-r"></span>
                </h3>
                <div class='clearfix types-content'>
                    <div v-for="item in tzsbworks"
                         class='index-card-container course-card-container container showstyee'>
                        <a class='course-card'
                           @click="goclass(item._id)">
                            <!--<div class="course-stat new">-->
                            <!--NEW-->
                            <!--</div>-->
                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span> ￥{{item.gzcxjg}}.00</div>
                                    <div class='course-card-price'><span>复审/换证</span>￥{{item.gzfsjg}}.00</div>
                                    <!--<div class='course-card-price'><span>初学</span>￥266.00</div>-->
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg000" v-if="fgwhyworks.length > 0">
            <div class='container-types clearfix'>
                <h3 class='types-title'><span
                        class="tit-icon icon-skill-l tit-icon-l"></span><em>非</em>／<em>高</em>／<em>危</em>／<em>行</em>／<em>业</em>／<em>培</em>／<em>训</em><span
                        class="tit-icon icon-skill-r tit-icon-r"></span>
                </h3>
                <div class='clearfix types-content'>
                    <div v-for="item in fgwhyworks"
                         class='index-card-container course-card-container container showstyee'>
                        <a class='course-card'
                           @click="goclass(item._id)">
                            <!--<div class="course-stat new">-->
                            <!--NEW-->
                            <!--</div>-->
                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span> ￥{{item.gzcxjg}}.00</div>
                                    <div class='course-card-price'><span>复审/换证</span>￥{{item.gzfsjg}}.00</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bgfff" v-if="zyjkworks.length > 0">
            <div class='container-types clearfix'>
                <h3 class='types-title'><span
                        class="tit-icon icon-tech-l tit-icon-l"></span><em>职</em>／<em>业</em>／<em>健</em>／<em>康</em>／<em>安</em>／<em>全</em>／<em>培</em>／<em>训</em><span
                        class="tit-icon icon-tech-r tit-icon-r"></span>
                </h3>
                <div class='clearfix types-content'>
                    <div v-for="item in zyjkworks"
                         class='index-card-container course-card-container container showstyee'>
                        <a class='course-card'
                           @click="goclass(item._id)">
                            <!--<div class="course-stat new">-->
                            <!--NEW-->
                            <!--</div>-->
                            <div class='course-card-top hashadow'>
                                <img class="course-banner" :src="item.imggz">

                                <div class="course-label">
                                    <label>{{item.gzxiangmu}}</label>
                                </div>
                            </div>
                            <div class='course-card-content'>
                                <h3 class='course-card-name'>{{item.gzleibie}}</h3>
                                <div class='clearfix course-card-bottom'>
                                    <allcount :work="item"/>
                                    <div class='course-card-price'><span>初学</span> ￥{{item.gzcxjg}}.00</div>
                                    <div class='course-card-price'><span>复审/换证</span>￥{{item.gzfsjg}}.00</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import allcount from '../components/allcount.vue'
    import './../assets/css/subject.css'

    export default {
        name: "Subject",
        data() {
            return {
                aqglworks: [],
                tzzyworks: [],
                tzsbworks: [],
                fgwhyworks: [],
                zyjkworks: [],
            }
        },
        components: {
            axios, allcount,
        },
        methods: {
            getdatascesehi: function () {
                axios.post("/Api/getworks").then(res => {
                    if (res.statusText == "OK") {
                        var works = res.data.data;
                        for (var obj in works) {
                            //给数据分类
                            switch (works[obj].gzleixing) {
                                case "安全管理人员":
                                    this.aqglworks.push(works[obj]);
                                    break;
                                case "特种作业人员":
                                    this.tzzyworks.push(works[obj]);
                                    break;
                                case "特种设备作业人员":
                                    this.tzsbworks.push(works[obj]);
                                    break;
                                case "非高危行业":
                                    this.fgwhyworks.push(works[obj]);
                                    break;
                                case "职业健康安全培训":
                                    this.zyjkworks.push(works[obj]);
                                    break;
                            }
                        }
                    }
                });
            },
            goclass(data) {
                this.$router.push({
                    name: 'Class',
                    params: {
                        id: data
                    }
                });
            },
        },
        mounted: function () {
            this.getdatascesehi();

        },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            }
        }
    }
</script>

<style>

</style>